import { Divider, Grid } from '@mui/material';
import { RiInformationLine } from '@remixicon/react';
import { PropsWithChildren } from 'react';
import Hint from 'src/components/atoms/Hint';
import { AgText } from 'src/components/ui';

type Props = PropsWithChildren<{
  label: string;
  subtitle?: string;
  leftChildren?: React.ReactNode;
  hint?: string;
  divider?: boolean;
}>;

// Helper for the basic settings field layout common on our settings pages
export default function SettingsSection(props: Props) {
  return (
    <>
      <Grid container spacing={4}>
        <Grid size={{ xs: 12, md: 4 }} sx={{ p: 2 }}>
          <div className="flex items-center gap-2">
            <AgText size="16" weight="bold">
              {props.label}
            </AgText>
            {props.hint && (
              <Hint title={props.hint} slotProps={{ tooltip: { sx: { fontSize: '14px' } } }}>
                <div className="flex items-center">
                  <RiInformationLine size={20} className="text-brand-6" style={{ userSelect: 'none' }} />
                </div>
              </Hint>
            )}
          </div>
          {props.subtitle && (
            <AgText size="14" color="secondary">
              {props.subtitle}
            </AgText>
          )}
          {props.leftChildren && <div className="mt-4">{props.leftChildren}</div>}
        </Grid>
        <Grid size={{ xs: 12, md: 8 }} sx={{ p: 2 }}>
          {props.children}
        </Grid>
      </Grid>
      {props.divider && <Divider sx={{ my: 2 }} />}
    </>
  );
}
